<script lang="ts" setup>
import api from "@/api";
import type { TFile, TFileType } from "@/assets/js/globalTypes";
import { useIsMobile } from "@/assets/js/helpers";
import { useProfileStore } from "@/store/profile";

const profileStore = useProfileStore();
definePage({
	name: "teacher.profile.documents",
});

watch(
	() => profileStore.profileChanges?.contract_types,
	() => {
		getDocumentTypes();
	},
	{ immediate: true },
);

const documentTypes = ref<TFileType[]>([]);
async function getDocumentTypes() {
	try {
		const res = await api.getFileTypes(
			profileStore.profileChanges.contract_types,
		);
		documentTypes.value = res.data.data;
	} catch (e) {
		console.error(e);
	}
}

const fileKey = ref(0);

const accountApproved = computed(() => profileStore.accountApproved);

const getDocumentTypesWithFiles = computed(() => {
	const res = [];
	for (const el of documentTypes.value) {
		const file = profileStore.profileChanges?.files?.find(
			(file) => file.ftp_code === el.ftp_code,
		);
		res.push({ doc_type: el, file });
	}
	return res;
});
function handleDeleteFile(file) {
	profileStore.removeFile(file);
	fileKey.value++;
}
const isMobile = useIsMobile();

function handleAddFile(file: TFile) {
	profileStore.addFile(file);
	fileKey.value++;
}
</script>
<template>
	<div>
		<div
			v-if="isMobile"
			class="sub-title-profile-page"
		>
			{{ $t("app.base.step") }} 6 |
			{{ $t("app.teacher.profileStepper.documents") }}
			<span v-tooltip.bottom="$t('app.teacher.profile.pendingValidation')">
				<i-material-symbols:alarm-outline-rounded
					v-if="profileStore.profilePending?.files?.length > 0"
				/>
			</span>
		</div>
		<info-icon
			class="help-icon-profile-page"
			:text="$t('app.teacher.profile.documentsHelperText')"
		/>
		<!-- <label class="sub-title with-padding">
			{{ $t("app.teacher.profileStepper.documents") }}
		</label> -->
		<div
			v-if="isMobile"
			class="teacher-profile-fake-circle"
		></div>
		<div class="content-wrap">
			<!-- <span
				v-tooltip.bottom="$t('app.teacher.profile.pendingValidation')"
				class="panding-validation-icon"
			>
				<i-material-symbols:alarm-outline-rounded
					v-if="profileStore.profilePending?.files?.length > 0 && !isMobile"
				/>
			</span> -->
			<small>* - {{ $t("app.base.requiredFields") }}</small>
			<!-- :key="fileKey" -->
			<div class="file-wrap">
				<DocumentItem
					v-for="documentType in getDocumentTypesWithFiles"
					:key="documentType.doc_type.ftp_code"
					:file-type="documentType.doc_type"
					:file="documentType.file"
					:account-approved="accountApproved"
					class="item"
					@delete-file="handleDeleteFile"
					@add-file="handleAddFile"
				/>
			</div>
		</div>
	</div>
</template>
<style scoped lang="scss">
.content-wrap {
	padding: 1rem;
	margin: 1rem 0;
	position: relative;

	@media screen and (max-width: $mobile) {
		background: $daidai-light-blue;
		margin: 0;
		padding: 0 1rem 1rem;
	}
	.file-wrap {
		display: flex;
		flex-wrap: wrap;
		gap: 1rem;
		.item {
			width: calc(50% - 1rem);

			@media screen and (max-width: 1300px) {
				width: 100%;
			}
		}
	}

	// .panding-validation-icon {
	// 	position: absolute;
	// 	top: 0;
	// 	right: 16px;
	// 	color: $daidai-yellow;
	// 	font-size: 40px;
	// }
}
</style>
